export default __webpack_public_path__ + "static/media/appDownload.8222ff00.png";